/**
 * Clear undefined/null/empty fields from an object. It mutates the object
 *
 * @category Object
 */
export function clearEmpty<T extends { [key: string]: any }>(object: T): T {
  Object.keys(object).forEach((key: string) => {
    if (object[key] == null || object[key] === '')
      delete object[key]
  })
  return object
}
